<template>
  <v-card class="mb-7">
    <v-card-text class="pa-5">
      <div class="d-sm-flex align-center">
        <div class="ml-3">
          <h2 class="font-weight-regular title">Cotizaciones</h2>
          <h6 class="body-2 mb-1 subtitle-2 font-weight-light">Datos de cotizaciones</h6>
        </div>
      </div>
    <!-- Header -->
    <div class="d-flex align-center pa-3">
    <!--
      <v-select
        v-model="filters.tipoPago"
        label="Tipo de pago"
        class="mr-5"
        :items="matriculaPaymentTypes"
        item-text="text"
        item-value="value"
        outlined
        dense
        style="max-width: 210px;"
        hide-details
        @change="filters.page = 1"
      />
 -->
      <v-select
        v-model="filters.seccion"
        label="Sección"
        class="mr-5"
        :items="secciones"
        item-text="nombre"
        item-value="id"
        outlined
        dense
        style="max-width: 210px;"
        hide-details
        clearable
        @change="filters.page = 1"
      />

      <v-select
          v-model="filters.estadoPago"
          label="Estado Cotización"
          class="mr-5"
          :items="estadoPagoItems"
          item-text="text"
          item-value="value"
          outlined
          dense
          style="max-width: 210px;"
          hide-details
          clearable
          @change="filters.page = 1"
      />
    <!--      
      <v-select
        v-model="filters.beneficio"
        label="Beneficio"
        class="mr-5"
        :items="beneficioItems"
        item-text="text"
        item-value="value"
        outlined
        dense
        style="max-width: 210px;"
        hide-details
        clearable
        @change="filters.page = 1"
      />
    -->
      <BaseDataRange
        style="max-width: 474px; margin: 0;"
        @sendStartDate="sendStartDate"
        @sendEndDate="sendEndDate"
        @clearStartDate="filters.startDate=''"
        @clearEndDate="filters.endDate=''"
      />
    </div>
    <!-- Fin header -->

    <div class="pa-3 pt-0" style="max-width: 420px;">
      <v-text-field
        v-model="searchLocal"
        prepend-inner-icon="mdi-magnify"
        dense
        outlined
        clearable
        hide-details
        label="Buscar coincidencias"
        @input="onLocalSearchInput"
      />
    </div>



    <!-- Table -->
      <v-data-table
        :headers="headerArray"
        :items="cotizaciones"
        :page.sync="filters.page"
        :items-per-page="pageSize"
        :server-items-length="totalPages"
        :loading="loading"
        hide-default-footer
        @click:row="showCotizacion"
      >
        <template v-slot:item.nombres="{ item }">
          <span class="font-weight-medium text-no-wrap">{{ item.nombres }}</span>
        </template>

        <template v-slot:item.seccion="{ item }">
          <span>{{ item.seccion_nombre }}</span>
        </template>

        <template v-slot:item.email="{ item }">
          <span>{{ item.email || '-' }}</span>
        </template>

        <template v-slot:item.estado="{ item }">
          <div class="d-flex flex-column align-center">
            <v-chip
              small
              label
              :color="estadoColor(item.estado)"
              dark
              class="font-weight-bold"
            >
              {{ item.estado }}
            </v-chip>
            <span
              v-if="item.estado === 'PAGADO'"
              class="text-no-wrap font-weight-bold mt-1"
              style="color: red; font-size: 10px;"
            >
              PROCESO DE MATRICULA INCOMPLETO
            </span>
          </div>
        </template>

        <template v-slot:item.created="{ item }">
          <span class="text-no-wrap">{{ item.created | moment("DD/MM/YYYY HH:mm") }}</span>
        </template>

        <template v-slot:item.modified="{ item }">
          <span class="text-no-wrap">{{ item.modified | moment("DD/MM/YYYY HH:mm") }}</span>
        </template>

        <!-- customizing pagination -->
        <template v-slot:footer="slotProps">
            <div class="pagination d-flex ml-auto mr-0 mt-5">
                <v-btn icon @click="filters.page > 1 ? filters.page--: ''" :disabled="filters.page === 1"><v-icon>mdi-chevron-left</v-icon></v-btn>
                <p class="ma-auto">{{ slotProps.props.pagination.page }} de {{ totalPages }}</p>
                <v-btn icon @click="filters.page < totalPages ? filters.page++: ''" :disabled="next === null"><v-icon>mdi-chevron-right</v-icon></v-btn>
            </div>
          </template>
        <!-- customizing pagination -->
      </v-data-table>
    <!-- Table -->
    </v-card-text>

  </v-card>
</template>

<script>
// import NProgress from "nprogress"
import { mapMutations, mapState } from 'vuex'
import BaseDataRange from '@/components/commonComponents/BaseDataRange'

export default {
  name: "TheCotizacionesTable",
  components: {
    BaseDataRange,
  },
  data: () => ({
    pageCount: 0,
    loading: false,
    cotizaciones: [],
    pageSize: 15,
    totalPages: 1,
    next: null,
    searchLocal: '',
    secciones: [],
    headerArray: [
      { text: 'Nombres', value: 'nombres', sortable: false, align: 'start' },
      { text: 'Apellidos', value: 'apellidos', sortable: false, align: 'start' },
      { text: 'Sección', value: 'seccion', sortable: false, align: 'start' },
      { text: 'Precio', value: 'precio', sortable: false, align: 'center' },
      { text: 'Precio sin descuento', value: 'precio_sin_descuento', sortable: false, align: 'center' },
      { text: 'Correo', value: 'email', sortable: false, align: 'center' },
      { text: 'Estado Cotización', value: 'estado', sortable: false, align: 'center' },
      { text: 'Creado', value: 'created', sortable: false, align: 'center' },
      { text: 'Modificado', value: 'modified', sortable: false, align: 'center' },
    ],
    estadoPagoItems: [
      { text: 'Todos', value: '' },
      { text: 'Cotizado', value: 'COTIZADO' },
      { text: 'Pagado', value: 'PAGADO' },
      { text: 'Completado', value: 'COMPLETADO' },
      { text: 'Cancelado', value: 'CANCELADO' }
    ],
    timeout: null,
    filters: {
      startDate: '',
      endDate: '',
      page: 1,
      search: '',
      seccion: null,
      estadoPago: '',
    },
  }),
  watch: {
    async searchGlobal () {
      this.fetchData()
    },
    filters: {
      deep: true,
      async handler () {
        await this.fetchData()
      }
    },
    seccionesStore (val) { if (Array.isArray(val) && val.length) this.secciones = val },
  },
  computed: {
    ...mapState({
      searchGlobal: (s) => s.searchGlobal,
      seccionesStore: (s) => s.secciones || [],
    }),
  },
  methods: {
    ...mapMutations(['SET_SEARCH']),
    async fetchCotizaciones(){
      const q = this.$route.query
      let url = `api/admin/matriculas/cotizaciones/?page_size=${this.pageSize}`
      url += `&page=${q.page || 1}`
      url += `&fecha_inicio=${q.fecha_inicio || ''}`
      url += `&fecha_fin=${q.fecha_fin || ''}`
      url += `&search=${q.search || ''}`
      url += `&estado=${q.estado_pago || ''}`
      url += `&seccion=${q.seccion || ''}`
      const cotizacionesResponse = await this.$http.get(url)
    this.next = cotizacionesResponse.data.next
      this.cotizaciones = cotizacionesResponse.data.results
      this.totalPages = Math.ceil(cotizacionesResponse.data.count / this.pageSize)
    },
    async fetchSecciones () {               
      const { data } = await this.$http.get('api/matriculas/secciones/')
      this.secciones = data
    },
    showCotizacion(cotizacion) {
      if (cotizacion.estado !== 'PAGADO') return
      this.$router.push({ name: 'UpdateCotizacion', params: { id: cotizacion.id } })
    },

    sendStartDate (item) {
      this.filters.page = 1
      this.filters.startDate = item
    },
    sendEndDate (item) {
      this.filters.page = 1
      this.filters.endDate = item
    },
    async fetchData () {
      clearTimeout(this.timeout)
      this.timeout = null
      this.timeout = setTimeout(async () => {
        await this.$router.replace(
          {
            path: this.$route.path,
            query: {
              fecha_inicio: this.filters.startDate,
              fecha_fin: this.filters.endDate,
              page: this.filters.page,
              search: this.searchGlobal,
              seccion: this.filters.seccion || '',
              estado_pago: this.filters.estadoPago || '',
            },
            scrollBehavior: {top: 0}
          },
        )
        await this.fetchCotizaciones()
      }, 600)
    },
    setInitialQueryParams () {
      const q = this.$route.query || {}
      this.filters = {
        startDate : q.fecha_inicio || '',
        endDate   : q.fecha_fin || '',
        page      : Number(q.page || 1),
        search    : q.search || '',
        seccion   : q.seccion || null,
        estadoPago: q.estado_pago || '',
      }
    },
    estadoColor (estado) {
      const map = { PAGADO: 'primary', COMPLETADO: 'success', COTIZADO: 'warning', CANCELADO: 'error' }
      return map[estado] || 'grey'
    },
    onLocalSearchInput () {
      this.SET_SEARCH(this.searchLocal)
    },
  },
  async mounted() {
    if (this.$route.query.search) {
      await this.SET_SEARCH(this.$route.query.search)
    }    
    this.searchLocal = this.searchGlobal || ''
    if (this.seccionesStore?.length) {
      this.secciones = this.seccionesStore
    } else {
      await this.fetchSecciones()
    }
    this.setInitialQueryParams()
    await this.fetchCotizaciones()

  }
};
</script>

<style lang="scss" scoped>
.enrollment_date {
  color: #1E88E5;
  font-size: 12px;
}

.app-chip {
  font-size: 10px;
  color: #FFF;
  background-color: rgba(0,0,0,.54);
  border-radius: 5px;
  padding: 5px;
}

.actions-btn {
  text-transform: none;
  letter-spacing: 0;
  width: 112px;
  min-width: 112px;

  &--secondary {
    background: rgba(0,0,0,.54) !important;
    color: white;
  }

  &--success {
    background: #4CAF50 !important;
    color: white;
  }
}
</style>
